<script setup lang="ts">
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import avatar from '@images/placeholder/avatar.png'

const { user, resetUser } = useAuthStore()
const { t } = useI18n()
const { $api } = useNuxtApp()

const userProfileList = [
    { type: 'divider' },
    {
        type: 'navItem',
        icon: 'ri-user-settings-line',
        title: t('profile'),
        value: '/profile',
  },
    {
        type: 'navItem',
        icon: 'ri-settings-3-line',
        title: t('change_password'),
        value: '/profile/change-password',
  },
    { type: 'divider' },
]

const router = useRouter()

const logout = async () => {
    await $api.auth.logout()
    resetUser()

    const authChannel = new BroadcastChannel('auth_sync')

    authChannel.postMessage('logout_success')
    authChannel.close()

    router.push('/login')
}
</script>

<template>
  <VAvatar
    class="cursor-pointer"
    size="38"
    role="button"
    tabindex="0"
  >
    <VAvatar>
      <VImg
        :src="user.profile_photo_url || avatar"
        :alt="`${user.name} Avatar`"
      />
    </VAvatar>
    <VMenu
      activator="parent"
      width="230"
      location="bottom end"
      offset="15px"
    >
      <VList>
        <VListItem
          to="/profile"
          link
          :active="false"
          class="background-transparent"
        >
          <template #prepend>
            <VListItemAction start>
              <NuxtLink
                to="/profile"
                class="cursor-pointer"
              >
                <VAvatar>
                  <VImg
                    :src="user.profile_photo_url || avatar"
                    :alt="`${user.name} Avatar`"
                  />
                </VAvatar>
              </NuxtLink>
            </VListItemAction>
          </template>

          <h6 class="text-sm font-weight-medium">
            {{ user.name }}
          </h6>
          <VListItemSubtitle class="text-capitalize text-disabled">
            {{ t('job_seeker') }}
          </VListItemSubtitle>
        </VListItem>
        <PerfectScrollbar :options="{ wheelPropagation: false }">
          <template
            v-for="item in userProfileList"
            :key="item.title"
          >
            <VListItem
              v-if="item.type === 'navItem'"
              :to="item.value"
            >
              <template #prepend>
                <VIcon
                  :icon="item.icon"
                  size="22"
                />
              </template>

              <VListItemTitle>{{ item.title }}</VListItemTitle>

              <template
                v-if="item.badgeProps"
                #append
              >
                <VBadge
                  inline
                  v-bind="item.badgeProps"
                />
              </template>
            </VListItem>

            <VDivider
              v-else
              class="my-1"
            />
          </template>

          <VListItem @click="logout">
            <template #prepend>
              <VIcon
                icon="ri-logout-box-r-line"
                size="22"
              />
            </template>
            <VListItemTitle>{{ t('logout') }}</VListItemTitle>
          </VListItem>
        </PerfectScrollbar>
      </VList>
    </VMenu>
  </VAvatar>
</template>
